import React from "react";

export default function SoldOut() {
  return (
    <div className="tc mt4 center mw6">
      <div className="mb3 f1 fw7 lh-title">Sorry!</div>

      <div className="lh-copy f4">
        It looks like this session has sold out! Please check back again for the
        time and date of the next class.
      </div>
    </div>
  );
}
